var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.notification.show
    ? _c(
        "div",
        {
          staticClass:
            "message is-primary is-light is-outlined is-rounded mt-6 mb-5",
          attrs: { "data-cy": "notifications-client" },
        },
        [
          _c(
            "header",
            { staticClass: "message-header" },
            [
              _vm._m(0),
              _c("p", [_vm._v(_vm._s(_vm.notification.title))]),
              _c(
                "b-button",
                {
                  staticClass: "toggleButton is-rounded ml-2",
                  attrs: {
                    size: "is-small",
                    "aria-expanded": _vm.notificationCollapse,
                    "aria-controls": "notification",
                  },
                  on: {
                    click: function ($event) {
                      _vm.notificationCollapse = !_vm.notificationCollapse
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fas",
                    class: {
                      "fa-angle-down": !_vm.notificationCollapse,
                      "fa-angle-up": _vm.notificationCollapse,
                    },
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "b-collapse",
            {
              staticClass: "message-body",
              attrs: { "aria-id": "notification", animation: "slide" },
              model: {
                value: _vm.notificationCollapse,
                callback: function ($$v) {
                  _vm.notificationCollapse = $$v
                },
                expression: "notificationCollapse",
              },
            },
            [
              _c(
                "div",
                { staticClass: "content p-4 has-text-centered is-block" },
                [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.notification.text)),
                  ]),
                  _vm.notification.url !== ""
                    ? _c(
                        "a",
                        {
                          staticClass: "button is-text is-small mt-0",
                          attrs: {
                            id: "notification-url",
                            href: "#notification-url",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.clickEvent(_vm.notification.url)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "fas fa-external-link" }),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.notification.textBtn)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fa-2x mr-2" }, [
      _c("i", { staticClass: "fa-solid fa-bell fa-shake" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }